import { AppAlerts, AppDataTable, AppSectionTitle } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useAlertsVisibility } from '@/shared-hooks/useAlertsVisibility'
import { createMypageColumns } from './-components/columns'
import { SalesFilterSection } from './-components/SalesFilterSection'
import { UserInfoCard } from './-components/UserInfoCard'
import { useMemberMonthlySalesWithPeriod } from './-hooks/useMemberMonthlySalesWithPeriod'

const ALERTS = [
  {
    type: 'warning' as const,
    content: 'インセンティブの確認を終えていない場合、「インセンティブ一覧」をクリックして確認をお願いします。',
  },
  {
    type: 'info' as const,
    content: (
      <div>
        「起票したオポに紐づく売り上げ一覧」は、オポの紐づけが実際のキャプテン活動と一致していることを、インセンティブ確定前にチェックするための一覧です。
        <br />
        お気づきの点がある場合は、営業、サービスマネージャにご相談、またはキャプテンサロンまでお問い合わせください。
      </div>
    ),
  },
  {
    type: 'info' as const,
    content: (
      <div>
        「起票したオポに紐づく売り上げ一覧」の「オポ金額」は最終的なインセンティブ金額とは必ずしも一致しません。
        <br />
        あくまで目安としてご認識ください。
      </div>
    ),
  },
]

export const Route = createFileRoute('/_authenticated/opportunities/mypage/')({
  component: MyPage,
})

function MyPage() {
  const [pageSize, setPageSize] = useState(20)

  const {
    filteredSales,
    availablePeriods,
    isLoading,
    error,
    selectedPeriod,
    setSelectedPeriod,
    searchText,
    setSearchText,
    copyToClipboard,
  } = useMemberMonthlySalesWithPeriod()

  const { visibleIndexes, onClose } = useAlertsVisibility(ALERTS.length)

  const columns = createMypageColumns(copyToClipboard)

  return (
    <div className='grid h-full grid-rows-[auto_minmax(0,1fr)]'>
      <AppSectionTitle
        collapsible
        content={
          <div className='p-4 space-y-2'>
            <AppAlerts alerts={ALERTS} visibleIndexes={visibleIndexes} onClose={onClose} />

            <UserInfoCard />

            <SalesFilterSection
              selectedPeriod={selectedPeriod}
              onPeriodChange={setSelectedPeriod}
              searchText={searchText}
              onSearchTextChange={setSearchText}
              availablePeriods={availablePeriods}
            />
          </div>
        }
      >
        マイページ
      </AppSectionTitle>

      <AppDataTable
        data={filteredSales}
        columns={columns}
        isLoading={isLoading}
        errorMessage={error ? `売上データの取得に失敗しました: ${error.message}` : undefined}
        pageSize={pageSize}
        onPageSizeChange={setPageSize}
        pageSizeOptions={[20, 40, 60]}
        emptyMessage='売上データがありません'
        defaultSortKey='sales_on'
        defaultSortDirection='desc'
        getRowKey={(row) => row.id}
        columnSelector={{ cookieKey: 'header-select-member-monthly-sales' }}
      />
    </div>
  )
}
